var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSlotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2ZM12 3.5C7.313 3.5 3.5 7.313 3.5 12C3.5 16.687 7.313 20.5 12 20.5C16.687 20.5 20.5 16.687 20.5 12C20.5 7.313 16.687 3.5 12 3.5Z",
    fill: "#22BBB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.313 3.5 3.5 7.313 3.5 12C3.5 16.687 7.313 20.5 12 20.5C16.687 20.5 20.5 16.687 20.5 12C20.5 7.313 16.687 3.5 12 3.5ZM11.6612 7.0954C12.0762 7.0954 12.4112 7.4314 12.4112 7.8454V12.2674L15.8162 14.2974C16.1712 14.5104 16.2882 14.9704 16.0762 15.3264C15.9352 15.5614 15.6862 15.6924 15.4312 15.6924C15.3002 15.6924 15.1682 15.6584 15.0472 15.5874L11.2772 13.3384C11.0512 13.2024 10.9112 12.9574 10.9112 12.6934V7.8454C10.9112 7.4314 11.2472 7.0954 11.6612 7.0954Z",
    fill: "#22BBB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSlotActive);
export default __webpack_public_path__ + "static/media/timeSlot-active.52a605e580788b8ed36b38bdd8e77c4f.svg";
export { ForwardRef as ReactComponent };